export default __webpack_public_path__ + "bb5de40edffdbd3ab519a2079528029b.woff2";